import PromiseField from './PromiseField';

export default PromiseField;
